import { render, staticRenderFns } from "./sidbarItem.vue?vue&type=template&id=2f9b7713&scoped=true&"
import script from "./sidbarItem.vue?vue&type=script&lang=js&"
export * from "./sidbarItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9b7713",
  null
  
)

export default component.exports